import gql from 'graphql-tag';

export const sendHelpdeskBulkMessageMutation = gql`
    mutation sendHelpdeskBulkMessage ($messageType: String!, $content: String!, $groups: [String]!){
        sendHelpdeskBulkMessage(messageType: $messageType, content: $content, groups: $groups) 
    }
`;
